import * as React from 'react';
import { connect } from 'react-redux';
import {Row, Col, Button} from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {IQuoteActions} from '../../../../services/quote/models';
import {push} from 'react-router-redux';

interface IPageProps {
  actions: {
    quote: IQuoteActions;
    push: (route: string) => void;
  };
}

class WhoWeAre extends React.Component<IPageProps> {
  private handleGetQuote = () => {
    const { actions } = this.props;
    actions.push('/');
    actions.quote.startQuoteProcess();
  }

  public render() {
    return (
      <div className="container">
        <Row>
          <Col sm={12}>
            <h2>Qui sommes-nous?</h2>

            <h3>Un assureur expert de la RC Professionnelle des Professions Réglementées</h3>
            <p>
              Depuis plus de 20 ans, notre équipe propose des contrats d’assurance RC Professionnelle et
              Garantie financière adaptés à certaines professions réglementées :
            </p>
            <ul>
              <li>Courtiers d’assurance et autres intermédiaires d’assurance</li>
              <li>Intermédiaires en opérations de banque et services de paiement</li>
              <li>Conseillers en investissements financiers</li>
              <li>Agents immobiliers</li>
              <li>Démarcheurs financiers</li>
            </ul>
            <p>
              Aujourd’hui, plus de 1 000 professionnels nous font confiance pour assurer leur activité.
            </p>

            <p>
              Notre objectif est d’innover dans notre démarche en offrant aux professionnels une approche simple, rapide
              et sécurisée, tout en leur garantissant d’être assuré par un expert de la RC Professionnelle des
              professions réglementées. Le développement de cette plateforme répond aux exigences de ces professionnels.
            </p>

            <h3>Notre expertise RC Pro digitalisée</h3>
            <p>
              Gagnez en tranquillité d’esprit grâce aux avantages de notre solution de souscription en ligne :
            </p>
            <ul>
              <li>Une expertise métier à votre service : nos 20 ans d’expérience et
                de savoir-faire disponibles en quelques clics</li>
              <li>Une souscription 100% digitale, du devis au paiement en ligne</li>
              <li>Des tarifs compétitifs, parmi les plus bas du marché</li>
              <li>Des garanties conformes aux obligations légales</li>
              <li>Une démarche simplifiée : questionnaire allégé ; aucun document requis</li>
              <li>Votre attestation d’assurance immédiatement disponible</li>
              <li>Transmission de vos données directement à l’ORIAS aux fins de renouvellement
                de votre inscription au Registre Unique</li>
              <li>Un espace personnel et sécurisé pour accéder à tout moment à vos documents</li>
              <li>La déclaration de vos sinistres depuis votre compte client</li>
              <li>Une équipe disponible pour toute demande d’adaptation</li>

            </ul>

            <h3>En savoir plus sur le groupe MS Amlin</h3>
            <p>
              MS Amlin est un assureur et réassureur international de premier plan, présent sur les marchés du Lloyd’s,
              au Royaume-Uni, en Europe continentale et aux Bermudes.
              Regroupant les activités de Mitsui Sumitomo Londres et Bermudes ainsi que les activités historiques du
              groupe Amlin, MS Amlin est spécialisé dans l’assurance des risques d’entreprises et dans la réassurance
              d’autres assureurs dans le monde entier.
              Le groupe est une filiale à part entière de la compagnie japonaise MS&AD et bénéficie à ce titre de la
              taille et de la solidité financière du huitième plus grand assureur non-vie au monde.
            </p>
            <p>
              Sur le marché français, MS Amlin est identifié comme un acteur alternatif aux compagnies traditionnelles
              pour proposer des solutions d’assurances sur-mesure aux PME / PMI, aux ETI, aux grandes entreprises et
              aux professionnels, en France comme à l’international. Les activités de souscription et d’indemnisation
              sont dédiées à l’assurance des risques dommages, responsabilité civile et maritime et aviation.
            </p>
            <p>
              MS Amlin est présent à Paris, Lyon, Marseille et Strasbourg et compte environ 100 collaborateurs.
            </p>
            <p>
              Pour en savoir plus sur MS Amlin, visitez notre
              <a href="https://www.msamlin.com/en/markets/France.html" target="_blank"> site web</a>.
            </p>

          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: {
      push: bindActionCreators(push, dispatch),
      quote: bindActionCreators({ ...quoteActions }, dispatch),
    },
  }),
)(WhoWeAre);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/WhoWeAre/index.tsx